import { render, staticRenderFns } from "./115.vue?vue&type=template&id=b88c6b6e&scoped=true&"
import script from "./115.vue?vue&type=script&lang=js&"
export * from "./115.vue?vue&type=script&lang=js&"
import style0 from "./115.vue?vue&type=style&index=0&id=b88c6b6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88c6b6e",
  null
  
)

export default component.exports